import React__default from 'react';
import { cn } from '../../../lib/utils.esm.js';

const ClientItem = ({
  client,
  onClick,
  selected
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: cn('proposal-client', {
      'proposal-client--selected': selected
    }),
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "font-semibold text-lg leading-none"
  }, `${client.firstName} ${client.lastName}`), client.phone && /*#__PURE__*/React__default.createElement("div", {
    className: "font-medium leading-none no-underline"
  }, client.phone), client.email && /*#__PURE__*/React__default.createElement("div", {
    className: "font-medium leading-none no-underline"
  }, client.email));
};

export { ClientItem as default };
//# sourceMappingURL=ClientItem.esm.js.map
